const navigation = document.querySelector(".navigation")
const menuItems = [...document.querySelectorAll(".has_sub_menu")];
const mainCont = document.querySelector(".header_cont");
const mainContent = document.querySelector(".mobile_menu_cont");
const menuMobile = document.querySelector(".menu_mobile");
const menuList =  document.querySelector(".menu_list_cont");
const mobile_sub = [...document.querySelectorAll(".menu_title")];
const submenuTitles = [...document.querySelectorAll(".submenu_title")];


const getRenderableHeight = (element) => {
    // Save the current styles
    const originalStyles = {
        visibility: element.style.visibility,
        maxHeight: element.style.maxHeight,
        display: element.style.display,
    };

    // Temporarily apply styles to make the element measurable
    Object.assign(element.style, {
        visibility: 'hidden',
        maxHeight: 'none',
        display: 'block',
    });

    // Get the renderable height
    const height = element.scrollHeight;

    // Restore original styles
    Object.assign(element.style, originalStyles);
    element.removeAttribute("style")

    return height;
};
// Usage example
const renderableHeight = getRenderableHeight(mainContent);
// console.log('Renderable height:', renderableHeight);

let prev_h = renderableHeight + "px";
// for desktop
menuItems.forEach(item => {
  const subMenu = item.querySelector("sub-menu");
  const prevMainItem = subMenu.previousElementSibling;
  const backLayer = subMenu.querySelector(".backLayer");
  
  if (subMenu) {
    item.addEventListener("click", function () {
      document.querySelectorAll("sub-menu").forEach(menu => {
        if (menu !== subMenu && menu.hasAttribute("open")) {
          menu.removeAttribute("open");
        }
      });
      document.querySelectorAll(".menu-item_main").forEach(mainItem => {
        if (mainItem !== prevMainItem) {
          mainItem.removeAttribute("open");
        }
      });
      subMenu.toggleAttribute("open");
      prevMainItem.toggleAttribute("open");
    });
  }
});

// for mobile
menuMobile.addEventListener("click", (e) => {
  const isOpen = mainCont.hasAttribute("open");
  mainCont.toggleAttribute("open");
  menuMobile.toggleAttribute("open");
  if (isOpen){
    mainContent.removeAttribute("style")
    setTimeout(()=> {
      const allOpn =  mainContent.querySelectorAll('div[open],ul[open],li[open]');
      allOpn.forEach(elm => {
        elm.removeAttribute("open");
      })
      prev_h = renderableHeight + "px";
      // console.log(1);
    },600)
  }
  else{
    mainContent.style.maxHeight = prev_h;
    navigation.style.height = prev_h;
    // console.log(2)
  }
});

mobile_sub.forEach(menuTitle => {
  const mobileMain = menuTitle.closest(".mobile_main");

  if (mobileMain && mobileMain.querySelector(".mobile_submenu")) {
    menuTitle.addEventListener("click", () => {
      const e = menuTitle.nextElementSibling;
      const e_height = e.offsetHeight;
      const transition = "transform calc(var(--duration-default) * 1.75) ease;";
      mobileMain.toggleAttribute("open");
      menuList.toggleAttribute("open");
      if ( mobileMain.hasAttribute("open")){
        mainContent.style.maxHeight = e_height + 5 +"px";
        navigation.style.height = e_height + 5 +"px";
        prev_h = e_height + 5 +"px";
        // console.log("back 1.1", prev_h)
      }else{
        mainContent.style.maxHeight = renderableHeight + "px";
        navigation.style.height = renderableHeight + "px";
        prev_h = menuList.offsetHeight + 5 +"px";
        // console.log("back 1.2", prev_h)
      }
    });
  }
});

submenuTitles.forEach((title) => {
  title.addEventListener("click", () => {
    const submenu = title.closest(".mobile_submenu");
    const parentSubmenu = title.closest(".submenu"); // Target the current .submenu container
    const currentGrandMenu = title.nextElementSibling; // Get the next sibling which should be .mobile_grandMenu
    const allGrandMenus = document.querySelectorAll(".mobile_grandMenu");
    const allSubmenus = document.querySelectorAll(".submenu");
    const e = title.nextElementSibling;
    const e_height = e.offsetHeight;

    // Close all other grand menus and remove 'open' from them
    allGrandMenus.forEach((menu) => {
      if (menu !== currentGrandMenu) {
        menu.removeAttribute("open");
      }
    });

    // Close all other submenus and remove 'open' from them
    allSubmenus.forEach((submenu) => {
      if (submenu !== parentSubmenu) {
        submenu.removeAttribute("open");
      }
    });

    // Toggle open for the current submenu and its grandMenu
    currentGrandMenu.toggleAttribute("open");
    parentSubmenu.toggleAttribute("open");
    submenu.toggleAttribute("open");
    if ( parentSubmenu.hasAttribute("open")){
        mainContent.style.maxHeight = e_height +"px";
        navigation.style.height = e_height +"px";
        prev_h = e_height +"px";
        // console.log("back 2.1", prev_h)
      }else{
        submenu.hasAttribute("open") ? '' :
        mainContent.style.maxHeight = submenu.offsetHeight +"px";
        navigation.style.height = submenu.offsetHeight +"px";
        submenu.hasAttribute("open") ? '' :
          prev_h = submenu.offsetHeight + 5 +"px";
        // console.log("back 2.2", prev_h)
      }
  });
});




